import '@/styles/normalize.css'
import '@/styles/index.less'
import '@/styles/main-object.less'

import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import vMediaQuery from 'v-media-query'
import axios from 'axios'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'

import App from './App.vue'
import router from './router'
import store from './store'

Vue.use(vMediaQuery, {
  methods: {
    isDesktop() {
      return vMediaQuery.methods.above('768px')
    },
  },
})
Vue.use(PerfectScrollbar)

Vue.config.productionTip = false

Vue.prototype.$http = axios

const r = router(store, Vue.prototype.$http)
sync(store, r)

new Vue({
  router: r,
  store,
  render: h => h(App),
}).$mount('#app')
